export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_LOGIN_STEP = 'SET_LOGIN_STEP';
export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';
export const ADD_ORDER_DATA = 'ADD_ORDER_DATA';
export const ADD_WALLET_DATA = 'ADD_WALLET_DATA';
export const ADD_PROFILE_DATA = 'ADD_PROFILE_DATA';

export const ADD_FILTER = 'ADD_FILTER';
export const CLEAR_FILTER = 'CLEAR_FILTER';

export const FORGET_PIN = "FORGET_PIN"

export const ADD_TO_HOMESCREEN = "ADD_TO_HOMESCREEN"
export const ADD_TO_HOMESCREEN_MODAL = "ADD_TO_HOMESCREEN_MODAL"
export const ADD_TO_HOMESCREEN_VISIT = "ADD_TO_HOMESCREEN_VISIT"

export const PORTFOLIO_HOLDINGS_TAB ='PORTFOLIO_HOLDINGS_TAB'

export const LOAD_ALL_PARTIES = 'LOAD_ALL_PARTIES'





export const userLogin = data => ({
    type: LOGIN,
    payload: {
        data:data
    }
});

export const userLogout = data => ({
    type: LOGIN,
    payload: {
        data:data
    }
});

export const setLoginStep = data => ({
    type: SET_LOGIN_STEP,
    payload: {
        data:data
    }
});

export const setActivePage = data => ({
    type: SET_ACTIVE_PAGE,
    payload: {
        data:data
    }
});

export const AddOrderData = data => ({
    type: ADD_ORDER_DATA,
    payload: {
        order_data:data,
    }
});

export const AddWalletData = data => ({
    type: ADD_WALLET_DATA,
    payload: {
        wallet_data:data,
    }
});

export const AddProfileData = data => ({
    type: ADD_PROFILE_DATA,
    payload: {
        profile_data:data,
    }
});

export const AddFilter = data => ({
    type: ADD_FILTER,
    payload: {
        filter:data,
    }
});

export const RemoveFilter = () => ({
    type: CLEAR_FILTER
});

export const setForgetPin = data => ({
    type: FORGET_PIN,
    payload: {
        data:data,
    }
});

export const addToHomeScreenToggler = data => ({
	type: ADD_TO_HOMESCREEN,
	payload: {
		data:data
	}
});

export const addToHomeScreenModalToggler = data => ({
	type: ADD_TO_HOMESCREEN_MODAL,
	payload: {
		data:data
	}
});
export const addToHomescreenVisitChecker = data => ({
	type: ADD_TO_HOMESCREEN_VISIT,
	payload: {
		data:data
	}
});
export const portfolioTabToggler = data => ({
	type: PORTFOLIO_HOLDINGS_TAB,
	payload: {
		data:data
	}
});

export const fetchAllParties = data => ({
    type: LOAD_ALL_PARTIES,
    payload: {
        data:data
    }
});
